import type { Persona, AvatarConfig } from '../types';


export const FreelanceAvatarConfig: AvatarConfig = {
    left: '460px',
    top: '410px',
    width: '400px',
    name: 'Rohan Gupta',
    image: 'https://files.ideoz.ai/freelancerAvatar.png',
    backgroundColor: '#D4FEFF',
};

export const WorkAvatarConfig: AvatarConfig = {
    left: '255px',
    top: '450px',
    width: '480px',
    name: 'Oliver Brown',
    image: 'https://files.ideoz.ai/workAvatar.png',
    backgroundColor: '#E3FFD4',
};

export const PersonalAvatarConfig: AvatarConfig = {
    left: '280px',
    top: '480px',
    width: '420px',
    name: 'Noor Iqbal',
    image: 'https://files.ideoz.ai/personalAvatar.png',
    backgroundColor: '#E9D4FF',
};

export const EducationAvatarConfig: AvatarConfig = {
    left: '370px',
    top: '340px',
    width: '470px',
    name: 'Daniel Harris',
    image: 'https://files.ideoz.ai/educationAvatar.png',
    backgroundColor: '#FFF0D4',
};

export const OthersAvatarConfig: AvatarConfig = {
    left: '370px',
    top: '390px',
    width: '440px',
    name: 'Sarah Adam',
    image: 'https://files.ideoz.ai/othersAvatar.png',
    backgroundColor: '#D4E7FF',
};

export const avatarConfigMap: Record<Persona, AvatarConfig> = {
    Freelance: FreelanceAvatarConfig,
    Work: WorkAvatarConfig,
    Personal: PersonalAvatarConfig,
    Education: EducationAvatarConfig,
    Others: OthersAvatarConfig,
};

export const backgroundColorMap: Record<Persona, string> = {
    Freelance: FreelanceAvatarConfig.backgroundColor,
    Work: WorkAvatarConfig.backgroundColor,
    Personal: PersonalAvatarConfig.backgroundColor,
    Education: EducationAvatarConfig.backgroundColor,
    Others: OthersAvatarConfig.backgroundColor,
};

